<template>
  <div class="selecet_products">
    <div v-if="isShow" class="bg_white pt16 pb16 pl16 pr16 ab">
      <p class="">N-selection商品の購入はN-selectionサイトからの購入に変更になります。<br>CONPUSを最新バージョンにアップデートすると、N-selectionサイトへ遷移します。<br>CONPUSは10時頃アップデート予定ですので、CONPUSをアップデート後に再度アクセスしてください。</p>
      <!-- <Flow v-bind:step="1"/>
      <ProductsList />

      <button class="cart_btn" :class="{'scrollBottom': cartPosition}" @click="cart()">
        <span class="">
          <span class="cart_image"><img src="../../assets/images/cart.png" alt=""></span>
          <span class="item_count rb">{{ cartCount }}</span>
        </span>
      </button>

      <cart />

      <div class="service_wrap bg_white mt12 pt16 pb48">
        <a href="#" class="btn_blue" @click.stop.prevent="checkCart()">次へ</a>
        <div class="mt25">
          <button type="button" name="button" onClick="android.close()" @click="closeWebView()" class="back btn_delete">戻る</button>
        </div>
      </div> -->
    </div>
    <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
  </div>

</template>

<script>
import close from '@/model/closeWebView'
import Check from '@/model/getToken'
import scrollPosition from '@/model/scrollPosition';
import { mapGetters } from 'vuex';
import Flow from '@/components/n-selection/Flow'
import ProductsList from '@/components/n-selection/ProductsList'
import Cart from '@/components/n-selection/Cart'


export default {
  components: {
    Flow,
    ProductsList,
    Cart
  },
  data () {
    return {
      isShow: true,
      cartPosition: false,
      isSelect: {
        bool: false
      },
      itemDetail: {
        open: false
      },
      cartAdd: [],
      isPermit: false,
      cartChange: false,
      deleteId: '',
    };
  },
  methods: {
    closeWebView() {
      close.closeWebView();
    },
    cart() {
      if(this.cartIsDisabled) return;
      scrollPosition.open();
      this.$store.commit('nselection/setCartIsOpen', true);
    },
    close() {
      this.cartOpen = false;
    },
    addItem(item) {
      this.cartAdd = item;
      this.itemCount += 1;
      this.isPermit = true;
    },
    checkCart() {
      if(this.nselectionOrderList.length > 0) {
        // カートに商品がなければ追加しない
        this.$router.push({ name: 'NSelectionDiscount' });
      }
    },
    permitCheck() {
      this.isPermit = false;
    },
    checkCartFromApi(data) {
      this.cartChange = data; // true
    },
    recieveDeleteProductId(deleteProductId) {
      this.deleteId = deleteProductId;
    },
    handleScroll() {
      const SelectProducts = document.querySelector('.selecet_products');
      if(!SelectProducts) return;
      const htmlHeight = document.getElementsByClassName("selecet_products")[0].clientHeight;
      const windowHeight = window.innerHeight;
      const scrollHeight = window.scrollY
      if (htmlHeight - (windowHeight + scrollHeight) == 0) {
        this.cartPosition = true;
      } else {
        this.cartPosition = false;
      }
    },
    initialized() {
      this.$store.commit('nselection/setCartCount', 0);
    },

  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  computed: mapGetters(
    'nselection', ['nselectionOrderList', 'cartCount', 'cartIsDisabled'],
  ),
  watch: {
    nselectionOrderList() {
      localStorage.setItem('nselectionOrderList', JSON.stringify(this.nselectionOrderList));
    }
  },
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      // localStorage.setItem('nselectionOrderComplete', true);
      if(JSON.parse(localStorage.getItem('nselectionOrderComplete'))) {
        localStorage.removeItem('deliveryTimeData');
        localStorage.removeItem('nselectionOrderList');
        localStorage.removeItem('creditData');

        this.$store.commit('nselection/setCartCount', 0);
        this.$store.dispatch('nselection/calcTotalPoint', { point: 0, reset: true });
        this.$store.commit('nselection/setWalletAmount', 0);
        this.$store.commit('nselection/setShipmentFee', 0);
        this.$store.commit('nselection/setUseWalletBillAmount', 0);
        this.$store.commit('nselection/setUseWallet', 0);
        this.$store.commit('nselection/setUsePurchasePoint', 0);
        this.$store.commit('nselection/setPaymentMethod', '');
        this.$store.commit('nselection/setPaymentMethodName', '');
        this.$store.commit('nselection/setCartIsDisabled', true);
        this.$store.dispatch('nselection/initializedProductsList');
        this.$store.dispatch('nselection/resetRequestData');
        this.$store.commit('nselection/setSelectWalletType', 'NO_USE');
        this.$store.commit('nselection/setInputWallet', 0);

        localStorage.removeItem('nselectionOrderComplete');
      }
      this.initialized();
      const OrderData = JSON.parse(localStorage.getItem('nselectionOrderList'));
      if(OrderData != null && OrderData.length > 0) {
        for (let i = 0; i < OrderData.length; i++) {
          this.$store.commit('nselection/setNselectionOrderList', OrderData[i]);
          this.$store.dispatch('nselection/calcCartCount', { status: 'add' });
        }
      }

    } else {
      this.isShow = false;
    }
  },
}
</script>

<style lang="css" scoped>
.btn_blue {
  margin-top: 26px;
}

/* カート */
.cart_btn {
  background-color: rgba(52, 154, 247, 0.8);
  border-radius: 100px;
  border: none;
  bottom: 100px;
  height: 64px;
  position: fixed;
  right: 28px;
  width: 64px;
  z-index: 0;
}

.cart_btn.scrollBottom {
  bottom: 10%;
}

.cart_btn .cart_image {
  display: block;
  margin: auto;
  width: 38px;
}

.cart_btn .item_count {
  align-items: center;
  background: #349AF7;
  border: 2px solid #FFFFFF;
  border-radius: 100px;
  color: #fff;
  display: flex;
  font-size: 14px;
  height: 25px;
  justify-content: center;
  position: absolute;
  right: -12px;
  top: -4px;
  width: 25px;
}

.btn_back {
  margin-top: 26px;
}

</style>



// WEBPACK FOOTER //
// src/views/n-selection/SelectProducts.vue